import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgEventCircle = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={20}
      height={20}
      viewBox="0 0 20 20"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <defs>
        <circle
          id="ui__icons__inline__event-circle_svg__a"
          cx={10}
          cy={10}
          r={10}
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="ui__icons__inline__event-circle_svg__b" fill="#fff">
          <use xlinkHref="#ui__icons__inline__event-circle_svg__a" />
        </mask>
        <circle cx={10} cy={10} r={9.5} stroke="currentColor" />
        <path
          fill="currentColor"
          d="M4.077 18.571H6.5v-2.423H4.077v2.423zm2.961 0h2.693v-2.423H7.038v2.423zM4.077 15.61H6.5v-2.692H4.077v2.692zm2.961 0h2.693v-2.692H7.038v2.692zm-2.961-3.23H6.5V9.955H4.077v2.423zm6.192 6.191h2.693v-2.423h-2.693v2.423zM7.04 12.38h2.69V9.956H7.038v2.423zm6.461 6.192h2.423v-2.423H13.5v2.423zm-3.23-2.961h2.692v-2.692H10.27v2.692zM7.307 8.34V5.919a.277.277 0 0 0-.27-.27H6.5a.277.277 0 0 0-.27.27V8.34c0 .143.127.269.27.269h.538c.143 0 .27-.126.27-.27zm6.192 7.27h2.423v-2.692H13.5v2.692zm-3.23-3.23h2.692V9.955h-2.693v2.423zm3.23 0h2.423V9.955H13.5v2.423zm.27-4.04V5.919a.277.277 0 0 0-.27-.27h-.538a.277.277 0 0 0-.27.27V8.34c0 .143.127.269.27.269h.538c.143 0 .27-.126.27-.27zM17 7.803v10.77c0 .588-.488 1.076-1.077 1.076H4.077A1.084 1.084 0 0 1 3 18.571V7.802c0-.589.488-1.077 1.077-1.077h1.077v-.807c0-.74.606-1.347 1.346-1.347h.538c.74 0 1.347.606 1.347 1.347v.807h3.23v-.807c0-.74.606-1.347 1.347-1.347h.538c.74 0 1.346.606 1.346 1.347v.807h1.077c.589 0 1.077.488 1.077 1.077z"
          mask="url(#ui__icons__inline__event-circle_svg__b)"
        />
      </g>
    </svg>
  );
};
export default SvgEventCircle;
